module.exports = __webpack_public_path__ + "img/15.cff75672.png";